/**
 * @ngdoc controller
 * @name dwtModule.DwtPaymentDetailsController
 */
'use strict';

angular.module('dwtModule').controller('DwtQualificationLettersController', [
  '$scope',
  '$stateParams',
  '$log',
  '$sessionStorage',
  '$filter',
  'userGroupService',
  'fileDownloadSvc',
  'cbpDownloadBlob',
  'PaginationSvc',
  'ModelWindowService',
  'QualificationLettersService',
  function (
    $scope,
    $stateParams,
    $log,
    $sessionStorage,
    $filter,
    userGroupService,
    fileDownloadSvc,
    cbpDownloadBlob,
    PaginationSvc,
    ModelWindowService,
    QualificationLettersService,
  ) {
    $scope.userId = $sessionStorage.userId;
    $scope.userType = $sessionStorage.usertype;
    $scope.loading = false;
    $scope.newLetter = {};

    $scope.showDeleteConfirmationDialog = false;

    if ($stateParams.qualificationLetterNumber) {
      $scope.newLetter.qualificationLetterNumber = $stateParams.qualificationLetterNumber;
      $scope.qualificationLetterNumberReadOnly = true;
    }

    if ($stateParams.ownerName) {
      $scope.newLetter.shareholderName = $stateParams.ownerName;
      $scope.ownerNameReadOnly = true;
    }

    $scope.newLetter.rsin = $stateParams?.rsin;

    $scope.dateValidationError = null;
    $scope.errorMessage = null;
    $scope.successMessage = null;

    $scope.modalLeftButton = $filter('translate')('label_confirm');
    $scope.modalRightButton = $filter('translate')('label_cancel');
    $scope.modalHeader = $filter('translate')('label_modalConfirmAction');

    $scope.loadQualificationLetters = function(pageNr, intermediaryUuid = null) {
      $scope.loading = true;
      QualificationLettersService.list(pageNr, intermediaryUuid)
        .then(function (response) {
          $scope.qualificationLetters = response.data.list;
          $scope.currentPage = pageNr;
          $scope.pager = PaginationSvc.GetPager(
            response.data.totalElements,
            pageNr
          );
        })
        .catch(function (error) {
          console.error('Error loading qualification letters:', error);
        })
        .finally(function () {
          $scope.loading = false;
        });
    };

    function loadIntermediaries() {
      $scope.loading = true;
      userGroupService.getIntermediaryGroupList('DWT', null)
        .query()
        .$promise.then(
        function (data) {
          $scope.intermediaries = data;
          $scope.loading = false;
        },
        function (error) {
          $log.debug(error);
          $scope.loading = false;
        }
      );
    }

    function clearMessages() {
      $scope.dateValidationError = null;
      $scope.errorMessage = null;
      $scope.successMessage = null;
    }

    $scope.hideErrorDeleteDialog = function() {
      clearMessages();
      $scope.showErrorDeleteDialog = false;
    };

    $scope.canCreateQualificationLetter = function() {
      return !$scope.dateValidationError
        && !!$scope.newLetter.qualificationLetterNumber
        && !!$scope.newLetter.shareholderName
        && !isNaN($scope.newLetter.validFrom)
        && !isNaN($scope.newLetter.validTill);
    };

    $scope.canSelectIntermediary = function() {
      return $scope.userType === 'AG';
    };

    $scope.createQualificationLetter = function() {
      clearMessages();
      if (!$scope.canCreateQualificationLetter()) {
        return;
      }
      $scope.loading = true;
      QualificationLettersService.create($scope.newLetter)
        .then(function () {
          $scope.successMessage = 'Qualification letter created successfully.';
          $scope.loadQualificationLetters($scope.currentPage);
        })
        .catch(function (err) {
          let errors = err.data.errors;
          if (!errors || !Array.isArray(errors) || errors.length === 0) {
            $scope.errorMessage = 'Error creating qualification letter';
          } else {
            $scope.errorMessage = errors[0].errorCode;
          }
        })
        .finally(function () {
          $scope.loading = false;
        });
    };

    $scope.confirmDelete = function(uuid) {
      if (!uuid) {
        return;
      }
      $scope.deleteUuid = uuid;
      $scope.showDeleteConfirmationDialog = true;
      $scope.modalBody = 'Are you sure you want to delete this qualification letter?';
    };

    $scope.delete = function() {
      clearMessages();
      if (!$scope.deleteUuid) {
        return;
      }
      $scope.loading = true;
      QualificationLettersService.delete($scope.deleteUuid)
        .then(function () {
          $scope.loadQualificationLetters($scope.currentPage);
          $scope.deleteUuid = null;
          $scope.successMessage = 'Qualification letter deleted successfully.';
          $scope.loading = false;
        })
        .catch(function (err) {
          let errors = err.data.errors;
          if (!errors || !Array.isArray(errors) || errors.length === 0) {
            $scope.errorMessage = 'Error deleting qualification letter';
          } else {
            $scope.errorMessage = errors[0].errorCode;
          }
          $scope.loading = false;
          ModelWindowService.showModelWindow('errorDeleteDialog');
        });
    };

    $scope.download = function (uuid) {
      $scope.loading = true;
      const url = 'v2/dwt/qualification-letter-payloads/' + uuid;
      fileDownloadSvc.downloadFile(url).then(
        function (response) {
          cbpDownloadBlob(response.file, response.fileName);
          $scope.loading = false;
        },
        function (error) {
          $log.debug(error);
          $scope.loading = false;
        }
      );
    };

    $scope.onPaginate = function (pageNr) {
      if (pageNr < 1) {
        return;
      }
      $scope.currentPage = pageNr;
      $scope.loadQualificationLetters(
        pageNr,
        $scope.filterByIntermediary || null
      );
    };

    $scope.onDateChanged = function (value, id) {
      clearMessages();
      if (!value) {
        return;
      }
      $scope.dateValidationError = null;

      const dateObj = new Date(value);
      $scope.newLetter[id] = isNaN(dateObj) ? null : dateObj;

      if ($scope.newLetter.validFrom && $scope.newLetter.validTill) {
        if (new Date($scope.newLetter.validFrom) > new Date($scope.newLetter.validTill)) {
          $scope.dateValidationError = 'The from date cannot be after the till date.';
        }
      }
    };

    $scope.onFileSelect = function (el) {
      clearMessages();
      $scope.newLetter.file = el.files[0];
      $scope.newLetter.filename = el.files[0].name;
      $scope.$apply(); // Ensure the scope is updated with the new file details
    };

    $scope.onSelectIntermediary = function(selected) {
      clearMessages();
      if ($scope.canSelectIntermediary() && selected) {
        $scope.newLetter.intermediaryUuid = selected.intermediaryUuid;
      }
    };

    $scope.onFilterByIntermediary = function (intermediary) {
      if ($scope.canSelectIntermediary()) {
        if (intermediary) {
          $scope.filterByIntermediary = intermediary.intermediaryUuid;
        } else {
          $scope.filterByIntermediary = null;
        }
        $scope.loadQualificationLetters(1, $scope.filterByIntermediary);
      }
    };

    $scope.loadQualificationLetters(1);
    if ($scope.canSelectIntermediary()) {
      loadIntermediaries();
    }
  }
]);
